<template>
  <div>
    <user-detail-title
        first-bread="公司招聘"
        second-bread="公司招聘查看"
        first-url="/user/recruitment"
        title-name="公司招聘查看"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">

        <el-form-item label="岗位名称" >
          <p>{{ LookData.post }}</p>
        </el-form-item>
        <el-form-item label="薪资">
          <p>{{ LookData.salary }}</p>
        </el-form-item>
        <el-form-item label="岗位职责">
          <pre>{{ LookData.duty }}</pre>
        </el-form-item>
        <el-form-item label="岗位要求">
          <pre>{{ LookData.demand }}</pre>
        </el-form-item>
        <el-form-item label="职位详情">
          <pre> {{ LookData.postDetail }}</pre>
        </el-form-item>
        <el-form-item label="邮箱">
          <p>{{ LookData.email }}</p>
        </el-form-item>
        <el-form-item label="联系电话">
          <p>{{ LookData.phoneNumber }}</p>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "RecruitmentLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/job/getById',{params:{
          id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }

  }
</script>

<style scoped>

</style>